// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"62d786a4","563":"9865c2b6","753":"021ad0e4","920":"a27fcd75"}[chunkId] + ".chunk.js";
};